import styled from 'styled-components';

export const StyledFilterDrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 44px !important;
`;
